<template>

  <div>
  <p class="p-top" id="page_top"><a href="#">▲<span>TOP<br>戻る</span></a></p>

  <footer role="content" class="footer">
    <section class="f-1">
      <div class="f-1box">
        <h2>
          <a :href="url">
            <img width="320" src="../../../assets/images/h_logo2.png" alt="株式会社ソナエル">
          </a>
        </h2>
      </div>
      <ul class="f-r-menu">
        <li><a :href="url">TOP</a></li>
        <li><a :href="`${url}/flow.html`">サービス案内</a></li>
        <li><a :href="`${url}/staff/`">相談員紹介</a></li>
        <li><a :href="`${url}/center/`">相談室</a></li>
        <li><a :href="`${url}/corporate/index.html`">会社案内</a></li>
        <li><a :href="`${url}/movies/`">ソナエルちゃんねる</a></li>
        <li></li>
      </ul>
      <ul class="f-cv">
        <li class="f-cv1">
          <a href="https://3816a0c3.form.kintoneapp.com/public/sonaeru-hp-toiawase">お問い合わせフォーム</a>
        </li>
        <li class="f-cv2">
          <a href="tel:0120-65-4246">電話お問い合わせ<br>
            <span>0120-65-4246</span>
          </a>
        </li>
      </ul>
    </section>
  </footer>

  <div class="f-bottom">
    <div class="f-bottom-in">
      <ul>
        <li><a :href="`${url}/sitemap.html`">サイトマップ</a></li>
        <li><a :href="`${url}/privacy.html`">プライバシーポリシー</a></li>
      </ul>
      <small class="copy">All contents copyright © Sonaeru Co., Ltd</small>
    </div>
  </div>

  </div>
</template>

<script>
  export default {
    name: 'AppFooter',
    components: {},
    data() {
      return {
        url: "https://www.sonaeru.co.jp" //本番
        //url: "https://stg.seniorhome.jp" //ステージング
      }
    },
    computed: {
    },
    methods: {
      showDropdown: function(e) {
        $(e.target).find('.dropdown').addClass('open');
      },
      hideDropdown: function(e) {
        $(e.target).find('.dropdown').removeClass('open');
      }
    },
  }

  $(function(){
    var pagetop = $('#page_top');
    pagetop.hide();

    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
            pagetop.fadeIn();
      } else {
            pagetop.fadeOut();
      }
    });
    pagetop.click(function () {
      window.scrollTo(0, 0);
      return false;
    });
  });
</script>
